import styled from "styled-components";

export const ImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  border: 1px solid gray;
`;
